import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  eulaContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1.5),
  },
  eulaType: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.primary,
    lineHeight: '24px',
    fontFamily: 'Inter, sans-serif',
  },
  btnLink: {
    padding: `0 !important`,
    minHeight: `${theme.spacing(2.5)} !important`,
  },
}))
